import ReducerRegistry from '../base/redux/ReducerRegistry';
import { RESET_WHITEBOARD, SET_WHITEBOARD_INFO, SET_WHITEBOARD_URL, SETUP_WHITEBOARD } from './actionTypes';
const DEFAULT_STATE = {
    isOpen: false,
    collabDetails: undefined,
    collabServerUrl: undefined,
    whiteboardUrl: undefined,
};
ReducerRegistry.register('features/whiteboard', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SETUP_WHITEBOARD: {
            return {
                ...state,
                isOpen: true,
                collabDetails: action.collabDetails,
                collabServerUrl: action.collabServerUrl
            };
        }
        case RESET_WHITEBOARD:
            return DEFAULT_STATE;
        case SET_WHITEBOARD_INFO: {
            return {
                ...state,
                openUsername: action.openUsername,
                openUserId: action.openUserId,
                openOccupantId: action.openOccupantId
            };
        }
        case SET_WHITEBOARD_URL:
            return {
                ...state,
                whiteboardUrl: action.whiteboardUrl
            };
    }
    return state;
});
